KEY_ENTER = 13
KEY_TAB = 9
KEY_ESC = 27

HTTP_STATUS_OK = 200
HTTP_STATUS_NO_CONTENT = 204

APP_ANDROID_DOWNLOAD_URL = 'http://a.app.qq.com/o/simple.jsp?pkgname=im.tower.plus.android'
